<template>
    <div class="stock-notify">
        <compWrapper title="库存异动通知管理" theme="primary">
            <div class="content-container">
                <div class="stock-notify-title color-primary">
                    库存产生异动将自动邮件通知选择的用户
                </div>
                <vTransfer
                    style="height:380px; margin: 0 auto;"
                    :data="userList"
                    identifier="value"
                    :target-keys="targetUserList"
                    :list-style="listStyle"
                    :filter-method="filterMethod"
                    :render-format="renderFormat"
                    filterable
                    @on-transfer="handleChange"
                ></vTransfer>
                <div class="margin-top-15 button-container">
                    <Button type="primary" @click="submit">保存</Button>
                </div>
            </div>
        </compWrapper>
        <Spin v-if="loading" fix></Spin>
    </div>
</template>

<script>
import {
    HttpUserList,
    HttpGetNotifyList,
    HttpSaveNotifyList
} from "@/service/stocknotify.js";
export default {
    data () {
        return {
			listStyle: {
				width: '45%',
				minWidth: '260px'
			},
            userList: [],
            targetUserList: [],
            loading: false
        }
    },
    async created () {
        this.loading = true;
        await this.getUserList();
        await this.getNotifyList();
        this.loading = false;
    },
    methods: {
        async getNotifyList () {
            await HttpGetNotifyList({
                search: {
                    EQ_organizationId: global.SYSID,
                    EQ_exceptionType: 0,
                    EQ_orderType: 700,
                    EQ_notifyType: 0
                }
            }).then(res => {
                console.log('notifylist', res);
                let contact = res.data[0] ? res.data[0].contact : "";
                if (!contact) return this.targetUserList = [];
                this.targetUserList = contact.split(",").map(id => {
                    return parseInt(id);
                });
                console.log(this.targetUserList);
            }, err => {
                this.$VMessage.error(err.message);
            });
        },
        async getUserList () {
            await HttpUserList().then(res => {
                this.userList = res.data.map(item => {
                    return {
                        label: `${item.name}(${item.email})`,
                        value: item.id,
                        attach: {
                            ...item
                        }
                    }
                });
                console.log(this.userList)
            }, err => {
                this.$VMessage.error(err.message);
            });
        },
        // 添加自定义搜索函数,不区分大小写
        filterMethod (data, query) {
            return data.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
        },
        renderFormat(item) {
            return item.description
                ? `${item.label}-${item.description}`
                : item.label;
        },
        handleChange (ids, direction, moveKeys) {
            console.log('ids', ids);
            this.targetUserList = ids;
            // this.targetUserList = this.userList.filter(item => {
            //     let result = [];
            //     ids.map(id => {
            //         if (item.value == id) {
            //             result.push(item);
            //         }
            //     });
            //     return result;
            // });
        },
        async submit () {
            console.log(this.targetUserList);
            this.loading = true;
            await HttpSaveNotifyList({
                userIds: this.targetUserList.join(','),
                orderType: 700,
                exType: 0
            }).then(res => {
                this.$VMessage.success(res.message);
            }, err => {
                this.$VMessage.error(err.message);
            });
            this.loading = false;
        }
    }
}
</script>

<style lang="scss" scoped>
.content-container {
    width: 80%;
    margin: 0 auto;
}
.stock-notify-title {
    font-size: 16px;
    font-weight: bold;
    margin: 15px 0;
}
.button-container {
    text-align: left;
}
</style>